<div class="modal-content" style="height: auto">
  <div class="modal-header">
    <h4 class="modal-title" id="exampleModalLabel1">Editar Rol</h4>
    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      mat-dialog-close
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-left">
    <form [formGroup]="form">
      <mat-form-field style="width: 100%">
        <mat-label>Nombre</mat-label>
        <input
          type="text"
          formControlName="nombre"
          matInput
          placeholder="Ingrese su nombre"
        />
        <mat-error *ngIf="form.get('nombre').hasError('required')"
          >El nombre es <strong>requerido</strong></mat-error
        >
        <mat-error *ngIf="form.get('nombre').hasError('pattern')"
          >Solo se admniten <strong>letras</strong></mat-error
        >
        <mat-error *ngIf="form.get('nombre').hasError('maxlength')"
          >El maximo de letras es <strong>15 </strong></mat-error
        >
      </mat-form-field>
      <br />
      <mat-checkbox
        style="margin: 10px; font-size: 16px"
        (click)="selectall(form.value)"
        >Seleccionar Todo</mat-checkbox
      >
      <div class="row">
        <div class="col-4">
          <h3>Gestión de Operaciones</h3>
          <div class="row">
            <div class="col-md-4">
              <mat-checkbox formControlName="CrearGestióndeOperaciones"
                >Crear Gestión de Operaciones</mat-checkbox
              >
              <mat-checkbox formControlName="ConsultarGestióndeOperaciones"
                >Consultar Gestión de Operaciones</mat-checkbox
              >
              <mat-checkbox formControlName="ActualizarGestióndeOperaciones"
                >Actualizar Gestión de Operaciones</mat-checkbox
              >
              <mat-checkbox formControlName="EliminarGestióndeOperaciones"
                >Eliminar Gestión de Operaciones</mat-checkbox
              >
            </div>
          </div>
          <h3>Casos</h3>
          <div class="row">
            <div class="col-md-2">
              <mat-checkbox formControlName="CrearCasos"
                >Crear Casos</mat-checkbox
              >
              <mat-checkbox formControlName="ConsultarSoloMisCasos"
                >Consultar Solo Mis Casos</mat-checkbox
              >
              <mat-checkbox formControlName="ConsultarCasos"
                >Consultar Casos</mat-checkbox
              >
              <mat-checkbox formControlName="ActualizarCasos"
                >Actualizar Casos</mat-checkbox
              >
              <mat-checkbox formControlName="ValidarCasos"
                >Validar Casos</mat-checkbox
              >
              <mat-checkbox formControlName="EliminarCasos"
                >Eliminar Casos</mat-checkbox
              >
            </div>
          </div>
          <h3>Sakes</h3>
          <div class="row">
            <div class="col-md-2">
              <mat-checkbox formControlName="CrearSakes"
                >Crear Sakes</mat-checkbox
              >
              <mat-checkbox formControlName="ConsultarSakes"
                >Consultar Sakes</mat-checkbox
              >
              <mat-checkbox formControlName="ActualizarSakes"
                >Actualizar Sakes</mat-checkbox
              >
              <mat-checkbox formControlName="EliminarSakes"
                >Eliminar Sakes</mat-checkbox
              >
            </div>
          </div>
          <h3>Registro</h3>
          <div class="row">
            <div class="col-md-2">
              <mat-checkbox formControlName="ConsultarRegistro"
                >Consultar Registro</mat-checkbox
              >
            </div>
          </div>
          <h3>Módulo Investigaciones Gerente</h3>
          <div class="row">
            <div class="col-md-2">
              <mat-checkbox formControlName="AdministradorDeTareas" >Administrador de Tareas</mat-checkbox >
              <mat-checkbox formControlName="AdministradorDeCasos" >Administrador de Casos</mat-checkbox >
            </div>
          </div>
        </div>
        <div class="col-4">
          <h3>Cuenta Maestra</h3>
          <div class="row">
            <div class="col-md-2">
              <mat-checkbox formControlName="CrearCuentaMaestra"
                >Crear Cuenta Maestra</mat-checkbox
              >
              <mat-checkbox formControlName="ConsultarCuentaMaestra"
                >Consultar Cuenta Maestra</mat-checkbox
              >
              <mat-checkbox formControlName="ActualizarCuentaMaestra"
                >Actualizar Cuenta Maestra</mat-checkbox
              >
              <mat-checkbox formControlName="EliminarCuentaMaestra"
                >Eliminar Cuenta Maestra</mat-checkbox
              >
            </div>
          </div>
          <h3>Tipos</h3>
          <div class="row">
            <div class="col-md-2">
              <mat-checkbox formControlName="CrearTipos"
                >Crear Tipos</mat-checkbox
              >
              <mat-checkbox formControlName="ConsultarTipos"
                >Consultar Tipos</mat-checkbox
              >
              <mat-checkbox formControlName="ActualizarTipos"
                >Actualizar Tipos</mat-checkbox
              >
              <mat-checkbox formControlName="EliminarTipos"
                >Eliminar Tipos</mat-checkbox
              >
            </div>
          </div>
          <h3>Casos/Sakes</h3>
          <div class="row">
            <div class="col-md-2">
              <mat-checkbox formControlName="ConsultarVinculaciónCasosSakes"
                >Consultar Vinculación Casos Sakes</mat-checkbox
              >
              <mat-checkbox formControlName="ActualizarVinculaciónCasosSakes"
                >Modificar Vinculación Casos Sakes</mat-checkbox
              >
            </div>
          </div>
          <h3>Crear Roles</h3>
          <div class="row">
            <div class="col-md-2">
              <mat-checkbox formControlName="CrearRoles"
                >Crear Roles</mat-checkbox
              >
              <mat-checkbox formControlName="ConsultarRoles"
                >Consultar Roles</mat-checkbox
              >
              <mat-checkbox formControlName="ActualizarRoles"
                >Actualizar Roles</mat-checkbox
              >
              <mat-checkbox formControlName="EliminarRoles"
                >Eliminar Roles</mat-checkbox
              >
            </div>
          </div>
          <h3>Módulo Investigaciones Analista</h3>
          <div class="row">
            <div class="col-md-2">
              <mat-checkbox formControlName="AnalistaDeCasos" >Analista de Casos</mat-checkbox >
            </div>
          </div>
        </div>
        <div class="col-4">
          <h3>Crear Usuario</h3>
          <div class="row">
            <div class="col-md-2">
              <mat-checkbox formControlName="CrearUsuario"
                >Crear Usuario</mat-checkbox
              >
              <mat-checkbox formControlName="ConsultarUsuario"
                >Consultar Usuario</mat-checkbox
              >
              <mat-checkbox formControlName="ActualizarUsuario"
                >Actualizar Usuario</mat-checkbox
              >
              <mat-checkbox formControlName="EliminarUsuario"
                >Eliminar Usuario</mat-checkbox
              >
            </div>
          </div>
          <h3>Otros</h3>
          <div class="row">
            <div class="col-md-2">
              <mat-checkbox formControlName="CargaMasiva"
                >Carga Masiva</mat-checkbox
              >
              <mat-checkbox formControlName="ConsultarConexiones"
                >Consultar Conexiones</mat-checkbox
              >
              <mat-checkbox formControlName="ActualizarConexiones"
                >Actualizar Conexiones</mat-checkbox
              >
              <mat-checkbox formControlName="Reportes">Reportes</mat-checkbox>
              <mat-checkbox formControlName="Grupos">Grupos</mat-checkbox>
            </div>
          </div>
          <h3>Widgets</h3>
          <div class="row">
            <div class="col-md-2">
              <mat-checkbox formControlName="CasosAnalizados"
                >Casos Analizados</mat-checkbox
              >
              <mat-checkbox formControlName="Canales">Canales</mat-checkbox>
              <mat-checkbox formControlName="Montos">Montos</mat-checkbox>
              <mat-checkbox formControlName="CasosDeTodosLosAnalistas"
                >Casos De Todos Los Analistas</mat-checkbox
              >
              <mat-checkbox formControlName="CanalesDeTodosLosAnalistas"
                >Canales De Todos Los Analistas</mat-checkbox
              >
            </div>
          </div>
        </div>
      </div>
      <button
        (click)="subirPermisos()"
        class="btn btn-info waves-effect float-right"
        [disabled]="form.status != 'VALID'"
      >
        <i class="far fa-save"></i>
        Guardar
      </button>
    </form>
  </div>
</div>
